import React from "react";
import PropTypes from "prop-types";
// import moment from "moment";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Heading from "components/Heading/Heading.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";
import { getMyUsers } from "../../services/advisorUsers.js";
import { getUserWidgets } from "../../services/dashboardDataProvider.js";
import SupersetDashboard from "components/SupersetDashboard/SupersetDashboard.jsx";
import WeeklyDeck from "components/WeeklyDeck/WeeklyDeck.jsx";

const styles = {
  trainingsCalenderContainer: {
    padding: "0px !important"
  },
  trainingsCardHeader: {
    padding: "15px !important",
    marginTop: "-20px !important",
    borderRadius: "3px !important",
    background: "linear-gradient(60deg, #275b95, #00acc1) !important",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 172, 193,.4) !important"
  }
};

class TraineeDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardWidgets: [],
      widgetsLoading: false,
      widgetsError: false,
      weekOffset: 0
    };
  }

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    const userName = this.props.match.params.userName;
    getMyUsers(this.props.axios).then(data => {
      const selectedUser = data.find(user => user.username === userName);
      this.setState(
        {
          users: data,
          userId: selectedUser.id,
          selectedTrainee: selectedUser,
          weekOffset: 0
        },
        () => {
          // Fetch widgets after userId is set
          this.fetchUserWidgets(selectedUser.id, 0);
        }
      );
    });
  }

  handleUserChange = value => {
    this.setState(
      {
        userId: value,
        selectedTrainee: this.state.users.find(user => user.id === value),
        weekOffset: 0
      },
      () => {
        // Fetch widgets when user changes
        this.fetchUserWidgets(value, 0);
      }
    );
  };

  fetchUserWidgets = (
    userId,
    weekOffset = this.state.weekOffset,
    options = {}
  ) => {
    if (!userId) return;

    this.setState({ widgetsLoading: true, widgetsError: false, weekOffset });

    getUserWidgets(this.props.axios, userId, weekOffset, options)
      .then(data => {
        this.setState({
          dashboardWidgets: data.results,
          widgetsLoading: false,
          widgetsError: false
        });
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.error("An error occurred while retrieving user widgets. ", err);
        this.setState({
          dashboardWidgets: [],
          widgetsLoading: false,
          widgetsError: true
        });
      });
  };

  handleChangeWeek = delta => {
    this.setState(
      prevState => ({ weekOffset: prevState.weekOffset + delta }),
      () => this.fetchUserWidgets(this.state.userId, this.state.weekOffset)
    );
  };

  handleGoToCurrentWeek = () => {
    this.fetchUserWidgets(this.state.userId, 0);
  };

  handleForcePerformanceMetricsRefresh = () => {
    this.fetchUserWidgets(this.state.userId, this.state.weekOffset, {
      forcePerformanceMetrics: true
    });
  };

  renderUsersSelectionBox() {
    let userOptions =
      this.state.users &&
      this.state.users.map(user => {
        return { text: user.username, value: user.id };
      });
    const selectedTraineeName =
      this.state.selectedTrainee && this.state.selectedTrainee.username;
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <CustomSelect
            labelText={selectedTraineeName || "Trainee"}
            items={userOptions}
            onChange={this.handleUserChange}
          />
        </GridItem>
      </GridContainer>
    );
  }

  render() {
    // eslint-disable-next-line no-unused-vars, react/prop-types
    const { classes, user } = this.props;
    const isAdvisor = user.roles && user.roles.includes("ADVISOR");
    const selectedTraineeName = this.state.selectedTrainee
      ? this.state.selectedTrainee.username
      : "";
    return (
      <div>
        <Heading
          textAlign="center"
          title="Trainee Dashboard"
          category={
            <span>{`Training Progress for ${selectedTraineeName}`}</span>
          }
        />
        {isAdvisor ? this.renderUsersSelectionBox() : null}
        <WeeklyDeck
          dashboardWidgets={this.state.dashboardWidgets}
          weekOffset={this.state.weekOffset}
          widgetsLoading={this.state.widgetsLoading}
          onChangeWeek={this.handleChangeWeek}
          onGoToCurrentWeek={this.handleGoToCurrentWeek}
        />
        <SupersetDashboard
          axios={this.props.axios}
          userId={this.state.userId}
          widgets={this.state.dashboardWidgets}
          widgetsLoading={this.state.widgetsLoading}
          widgetsError={this.state.widgetsError}
          onForcePerformanceMetrics={this.handleForcePerformanceMetricsRefresh}
        />
      </div>
    );
  }
}

TraineeDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  axios: PropTypes.object.isRequired
};

export default withStyles(styles)(TraineeDashboard);
